import React from 'react';
import { motion } from 'framer-motion';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="legal-page">
      <section className="page-hero">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1>Privacy Policy</h1>
            <p>Your privacy matters to us. Last updated: February 2026</p>
          </motion.div>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <div className="legal-wrapper">

            <div className="legal-section">
              <h2>1. Introduction</h2>
              <p>
                Pack N Fly ("we", "our", "us") is committed to protecting the privacy of our customers 
                and website visitors. This Privacy Policy explains how we collect, use, disclose, and 
                safeguard your information when you visit our website or use our international courier 
                services from Chandigarh.
              </p>
              <p>
                By using our website or services, you agree to the collection and use of information 
                in accordance with this policy.
              </p>
            </div>

            <div className="legal-section">
              <h2>2. Information We Collect</h2>
              <h3>Personal Information</h3>
              <p>When you use our services or fill out forms on our website, we may collect:</p>
              <ul>
                <li>Full name</li>
                <li>Mobile phone number</li>
                <li>Email address</li>
                <li>Pickup address and city</li>
                <li>Destination country and address</li>
                <li>Shipment details (type, weight, contents)</li>
                <li>Payment information (processed securely through third-party payment gateways)</li>
              </ul>

              <h3>Automatically Collected Information</h3>
              <p>When you visit our website, we may automatically collect:</p>
              <ul>
                <li>IP address and browser type</li>
                <li>Device information and operating system</li>
                <li>Pages visited and time spent on our website</li>
                <li>Referring website or source</li>
                <li>Cookies and similar tracking technologies</li>
              </ul>
            </div>

            <div className="legal-section">
              <h2>3. How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul>
                <li>Process and fulfill your courier shipments</li>
                <li>Provide shipment tracking and delivery updates via SMS, WhatsApp, or email</li>
                <li>Respond to your enquiries and provide customer support</li>
                <li>Generate shipping quotes and invoices</li>
                <li>Handle customs documentation and clearance</li>
                <li>Improve our website and services</li>
                <li>Send promotional offers and updates (only with your consent)</li>
                <li>Comply with legal obligations</li>
              </ul>
            </div>

            <div className="legal-section">
              <h2>4. Information Sharing</h2>
              <p>We may share your information with:</p>
              <ul>
                <li><strong>Courier Partners:</strong> International shipping carriers (DHL, FedEx, Aramex, etc.) to fulfill your shipments</li>
                <li><strong>Customs Authorities:</strong> As required for international shipment clearance</li>
                <li><strong>Payment Processors:</strong> For secure payment processing</li>
                <li><strong>Legal Authorities:</strong> When required by law or to protect our rights</li>
              </ul>
              <p>We do not sell, rent, or trade your personal information to third parties for marketing purposes.</p>
            </div>

            <div className="legal-section">
              <h2>5. Data Security</h2>
              <p>
                We implement appropriate technical and organizational measures to protect your personal 
                information against unauthorized access, alteration, disclosure, or destruction. Our 
                website uses SSL encryption to secure data transmission.
              </p>
              <p>
                However, no method of transmission over the internet is 100% secure, and we cannot 
                guarantee absolute security of your data.
              </p>
            </div>

            <div className="legal-section">
              <h2>6. Cookies</h2>
              <p>
                Our website uses cookies to enhance your browsing experience. Cookies are small text 
                files stored on your device that help us understand how you use our website. You can 
                control cookie settings through your browser preferences.
              </p>
              <p>We use cookies for:</p>
              <ul>
                <li>Website functionality and user preferences</li>
                <li>Analytics and performance monitoring (Google Analytics)</li>
                <li>Advertising and remarketing (Google Ads)</li>
              </ul>
            </div>

            <div className="legal-section">
              <h2>7. Your Rights</h2>
              <p>You have the right to:</p>
              <ul>
                <li>Access the personal information we hold about you</li>
                <li>Request correction of inaccurate information</li>
                <li>Request deletion of your personal data</li>
                <li>Opt out of promotional communications</li>
                <li>Withdraw consent for data processing</li>
              </ul>
              <p>
                To exercise any of these rights, please contact us at{' '}
                <a href="mailto:packnfly96@gmail.com">packnfly96@gmail.com</a> 
                or call <a href="tel:+918847428801">+91 8847428801</a>.
              </p>
            </div>

            <div className="legal-section">
              <h2>8. Third-Party Links</h2>
              <p>
                Our website may contain links to third-party websites. We are not responsible for the 
                privacy practices or content of these external sites. We encourage you to read the 
                privacy policies of any third-party websites you visit.
              </p>
            </div>

            <div className="legal-section">
              <h2>9. Changes to This Policy</h2>
              <p>
                We may update this Privacy Policy from time to time. Any changes will be posted on this 
                page with an updated revision date. We encourage you to review this policy periodically.
              </p>
            </div>

            <div className="legal-section">
              <h2>10. Contact Us</h2>
              <p>If you have any questions about this Privacy Policy, please contact us:</p>
              <ul>
                <li><strong>Company:</strong> Pack N Fly</li>
                <li><strong>Email:</strong> <a href="mailto:packnfly96@gmail.com">packnfly96@gmail.com</a></li>
                <li><strong>Phone:</strong> <a href="tel:+918847428801">+91 8847428801</a></li>
                <li><strong>WhatsApp:</strong> <a href="https://wa.me/918847428801" target="_blank" rel="noopener noreferrer">+91 8847428801</a></li>
                <li><strong>Address:</strong> Plot No 5A, Industrial Area, Phase 2, Panchkula, Haryana</li>
              </ul>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
